
import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Chip,
    Stack,
    Divider
} from '@mui/material';

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const ExpirationAnalysis = ({ analysisData }) => {
    if (!analysisData || analysisData.length === 0) return null;

    return (
        <Box sx={{
            height: '100%',
            overflowY: 'auto',
            pr: 1,
            /* God Tier Hover-Only Scrollbar */
            '&::-webkit-scrollbar': {
                width: '5px',
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '10px',
            },
            '&:hover::-webkit-scrollbar-thumb': {
                background: 'rgba(255, 255, 255, 0.2)',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: 'rgba(255, 255, 255, 0.35)',
            }
        }}>
            <Stack spacing={2}>
                {analysisData.map((item, index) => (
                    <Card key={index} sx={{
                        background: 'rgba(30, 41, 59, 0.7)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: '8px',
                        transition: 'transform 0.2s',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: 4,
                            borderColor: 'rgba(255, 255, 255, 0.2)'
                        }
                    }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                            {/* Header */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ color: '#fff', fontSize: '0.9rem', fontWeight: 700 }}>
                                    {formatDate(item.date)}
                                </Typography>
                                <Chip
                                    label={item.sentiment}
                                    size="small"
                                    sx={{
                                        height: '24px',
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        bgcolor: item.sentiment_color === 'success' ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)',
                                        color: item.sentiment_color === 'success' ? '#4ade80' : '#f87171',
                                        border: '1px solid',
                                        borderColor: item.sentiment_color === 'success' ? 'rgba(34, 197, 94, 0.3)' : 'rgba(239, 68, 68, 0.3)',
                                    }}
                                />
                            </Box>

                            {/* Narrative */}
                            <Typography sx={{ color: '#cbd5e1', fontSize: '0.85rem', lineHeight: 1.5, mb: 2 }}>
                                {item.summary}
                            </Typography>

                            <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 1.5 }} />

                            {/* Key Levels */}
                            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                <Typography sx={{ color: '#4ade80', fontSize: '0.8rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    Call Wall: <span style={{ color: '#fff', fontWeight: 400 }}>${Math.round(item.levels.call_wall)}</span>
                                </Typography>
                                <Typography sx={{ color: '#f87171', fontSize: '0.8rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    Put Wall: <span style={{ color: '#fff', fontWeight: 400 }}>${Math.round(item.levels.put_wall)}</span>
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Stack>
        </Box>
    );
};

export default ExpirationAnalysis;
